import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Welcome from './pages/Welcome';
import Login from './pages/Login';
import CreateAccount from './pages/CreateAccount';
import { apiStrings } from './api/api';
import ConfirmUser from './pages/ConfirmUser';
import LoginRequiredTest from './pages/LoginRequiredTest';
import LoggedInLanding from './pages/LoggedInLanding';
import ContactListPage from './pages/ContactListPage';
import TimeLinePage from './pages/TimeLinePage';
import FamilyTreePage from './pages/FamilyTreePage';
import CreateAccountLandingPage from './pages/CreateAccountLandingPage';
import ReunionPage from './pages/ReunionPage';
import TestPhotoPage from './pages/TestPhotoPage';
import ReunionPhotoPage from './pages/ReunionPhotoPage';
import ForumLandingPage from './pages/ForumLandingPage';
import PostPage from './pages/PostPage';
import CreatePostPage from './pages/CreatePostPage';
import NextReunionPage from './pages/NextReunionPage';
import CreateCommentPage from './pages/CreateCommentPage';

const strings = apiStrings();

const router = createBrowserRouter([
    {
        path: "/",
        element: <Welcome strings={strings} />,
    },
    {
        path: "/login",
        element: <Login />,
    },
    {
        path: "/create",
        element: <CreateAccount />,
    },
    {
        path: "/confirmUser",
        element: <ConfirmUser />,
    },
    {
        path: "/loginRequiredTest",
        element: <LoginRequiredTest />,
    },
    {
        path: "/landing",
        element: <LoggedInLanding />,
    },
    {
        path: "/contacts",
        element: <ContactListPage />,
    },
    {
        path: "/timeline",
        element: <TimeLinePage />,
    },
    {
        path: "/tree",
        element: <FamilyTreePage />,
    },
    {
        path: "/create-success",
        element: <CreateAccountLandingPage />,
    },
    {
        path: "/reunion/:year",
        element: <ReunionPage />,
    },
    {
        path: "/test-photo",
        element: <TestPhotoPage />,
    },
    {
        path: "/reunionPhotos/:folder",
        element: <ReunionPhotoPage />,
    },
    {
        path: "/forum",
        element: <ForumLandingPage />,
    },
    {
        path: "/post/create",
        element: <CreatePostPage />,
    },
    {
        path: "/post/:uuid",
        element: <PostPage />,
    },
    {
        path: "/post/:uuid/comment",
        element: <CreateCommentPage />,
    },
    {
        path: "/nextReunion",
        element: <NextReunionPage />,
    },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <div className="root">
            <RouterProvider router={router} />
        </div>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
